const PauseIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 104 104"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g filter="url(#filter0_f_1163_7350)">
      <circle cx="52" cy="52" r="21" fill="white" fillOpacity="0.5" />
    </g>
    <path
      d="M47 58V46M57 58V46M72 52C72 63.0457 63.0457 72 52 72C40.9543 72 32 63.0457 32 52C32 40.9543 40.9543 32 52 32C63.0457 32 72 40.9543 72 52Z"
      stroke="white"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <defs>
      <filter
        id="filter0_f_1163_7350"
        x="0"
        y="0"
        width="104"
        height="104"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feGaussianBlur
          stdDeviation="15.5"
          result="effect1_foregroundBlur_1163_7350"
        />
      </filter>
    </defs>
  </svg>
);

export default PauseIcon;
